// Holds the logged-in partner and exposes login/logout. Checks the session once
// on mount so a refresh keeps the user signed in.
import { createContext, useContext, useEffect, useState } from 'react';
import { authApi } from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [partner, setPartner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authApi
      .me()
      .then(setPartner)
      .catch(() => setPartner(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const p = await authApi.login(email, password);
    setPartner(p);
    return p;
  };

  const logout = async () => {
    await authApi.logout();
    setPartner(null);
  };

  return (
    <AuthContext.Provider value={{ partner, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
